export default __webpack_public_path__ + "static/media/i17.63b1c81d.jpeg";